module.exports = __webpack_public_path__ + "static/media/fullbackground-crazy8s.3a3c4cd2.png";